import { render, staticRenderFns } from "./UserAddressEdit.vue?vue&type=template&id=dea10ed2&"
import script from "./UserAddressEdit.vue?vue&type=script&lang=js&"
export * from "./UserAddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports